module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Electric/Socket-eu-f5c9ea4af3367bdec40da4acac924aa5.svg";